import template from './manage-sms-notification-view.html';

@Inject('gettextCatalog', 'appFactory')
class ManageSmsNotificationViewController {
  $onChanges(changes) {
    this.smsEnabled = !!changes.smsEnabled.currentValue;
  }
}

export default class ManageSmsNotificationViewComponent {
  constructor() {
    this.controller = ManageSmsNotificationViewController;
    this.template = template;
    this.bindings = {
      smsEnabled: '<',
      showSubscriptionDialog: '&',
      isShown: '<',
      disabled: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-sms-notification/components/manage-sms-notification-view/manage-sms-notification-view-component.js